import axios, { AxiosResponse } from 'axios'
import PromiseCache from '@/lib/PromiseCache'
import { Base64 } from 'js-base64';

// const baseURL = 'https://i7vllara7b.execute-api.us-east-1.amazonaws.com/dev/';

// const baseURL = 'https://api.podspast.com/';
// const baseURL = window.location.origin + '/api/';
// const cloudFunctionsBaseURL = 'https://us-central1-podspast.cloudfunctions.net/'

const localDevBaseURL = 'http://localhost:5001/podspast/us-central1/'
const productionBaseURL = 'https://us-central1-podspast.cloudfunctions.net/'

export const cloudFunctionsBaseURL = window.location.hostname === 'localhost' ? localDevBaseURL : productionBaseURL

function loadFeedDataRaw(podcastURL: string) {
  return axios.get(cloudFunctionsBaseURL + 'feedData', {
    params: {
      podcastURL: Base64.encodeURI(podcastURL),
    },
  });
}

export default class API {
  public static search(query: string) {
    const directorySearchURL = cloudFunctionsBaseURL + 'search?q=' + encodeURIComponent(query)
    return axios.get(directorySearchURL);
  }

  public static loadFeedData(podcastURL: string) {
    return API.feedDataCache.get(podcastURL)
  }

  private static feedDataCache = new PromiseCache(loadFeedDataRaw)
}
